// @flow

export const PAYMENT_TYPE_INVOICE: 'INVOICE' = 'INVOICE';
export const PAYMENT_TYPE_SEPA: 'SEPA' = 'SEPA';
export const PAYMENT_TYPE_CC: 'cc' = 'cc';
export const PAYMENT_TYPE_ALTERNATIVE: 'ALTERNATIVE_OPTION' =
  'ALTERNATIVE_OPTION';
export const PAYMENT_TYPE_PAYPAL: 'PAYPALLIGHT' = 'PAYPALLIGHT';
export const PAYMENT_TYPE_PAYPAL_EXTERNAL: 'PAYPAL' = 'PAYPAL';
export const PAYMENT_TYPE_INSTANTPAYMENT: 'INSTANTBANKTRANSFERLIGHT' =
  'INSTANTBANKTRANSFERLIGHT';

export type TypeOfPayment =
  | typeof PAYMENT_TYPE_INVOICE
  | typeof PAYMENT_TYPE_SEPA
  | typeof PAYMENT_TYPE_CC
  | typeof PAYMENT_TYPE_ALTERNATIVE
  | typeof PAYMENT_TYPE_PAYPAL
  | typeof PAYMENT_TYPE_PAYPAL_EXTERNAL
  | typeof PAYMENT_TYPE_INSTANTPAYMENT;

export type CreditCard = {
  code: string,
  name: string,
  available: boolean,
  information?: string,
  price?: number,
};

export type PaymentType = {
  code: TypeOfPayment,
  name: string,
  authHash?: string,
  information?: string,
  price?: number,
  cards?: CreditCard[],
  extras?: CreditCard[],
  isFake?: boolean,
  available: boolean,
};
